/* ark-article-v2.js — TOC, scrollspy, progress, table wrap, inline band, body-block dedupe */
(function () {
  /* signup success state: cache-proof, driven by the redirect param */
  if (/[?&](customer_posted|contact_posted)=true/.test(location.search)) {
    [].slice.call(document.querySelectorAll('.av2-cap form, .av2-band form')).forEach(function (f) {
      var host = f.closest('[data-success]');
      var msg = (host && host.getAttribute('data-success')) ||
                'You are in. Use code FIRST15 for 15% off your first order.';
      var p = document.createElement('p');
      p.className = 'av2-success';
      p.textContent = msg;
      f.parentNode.insertBefore(p, f);
      f.hidden = true;
    });
  }

  var content = document.getElementById('av2-article');
  if (!content) return;

  /* wrap tables for mobile scroll */
  [].slice.call(content.querySelectorAll('table')).forEach(function (t) {
    if (t.parentElement && t.parentElement.classList.contains('av2-tblwrap')) return;
    var w = document.createElement('div');
    w.className = 'av2-tblwrap';
    t.parentNode.insertBefore(w, t);
    w.appendChild(t);
  });

  /* reading progress */
  var prog = document.getElementById('av2-progress');
  if (prog) {
    var onScrollProg = function () {
      var h = document.documentElement, max = h.scrollHeight - h.clientHeight;
      prog.style.width = (max > 0 ? (h.scrollTop / max * 100) : 0) + '%';
    };
    window.addEventListener('scroll', onScrollProg, { passive: true });
    onScrollProg();
  }

  /* hide a body H2 block: the heading plus following siblings up to the next H2 */
  function hideBlock(h2) {
    var el = h2;
    while (el) {
      var next = el.nextElementSibling;
      el.hidden = true;
      if (!next || next.tagName === 'H2') break;
      el = next;
    }
  }

  var allH2s = [].slice.call(content.querySelectorAll('h2'));

  /* the rail TOC replaces any hand-written body Table of Contents */
  allH2s.filter(function (h) {
    return /^\s*table of contents\s*$/i.test(h.textContent);
  }).forEach(hideBlock);

  /* the structured FAQ section replaces any body FAQ block */
  if (document.getElementById('av2-faq')) {
    allH2s.filter(function (h) {
      return /frequently asked questions|^\s*faqs?\b/i.test(h.textContent);
    }).forEach(hideBlock);
  }

  /* build TOC from remaining visible H2s */
  var hs = allH2s.filter(function (h) { return !h.hidden; });
  var lists = [document.getElementById('av2-toc-list'), document.getElementById('av2-toc-mob-list')];
  hs.forEach(function (h) {
    if (!h.id) h.id = 'av2-' + h.textContent.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
    lists.forEach(function (ul) {
      if (!ul) return;
      var li = document.createElement('li'), a = document.createElement('a');
      a.href = '#' + h.id;
      a.textContent = h.textContent;
      li.appendChild(a);
      ul.appendChild(li);
    });
  });

  /* add the on-page FAQ section to the TOC when present */
  var faqSection = document.getElementById('av2-faq');
  if (faqSection) {
    var faqTitle = faqSection.querySelector('h2');
    lists.forEach(function (ul) {
      if (!ul || !faqTitle) return;
      var li = document.createElement('li'), a = document.createElement('a');
      a.href = '#av2-faq';
      a.textContent = faqTitle.textContent;
      li.appendChild(a);
      ul.appendChild(li);
    });
  }

  /* scrollspy */
  var links = lists[0] ? [].slice.call(lists[0].querySelectorAll('a')) : [];
  if (links.length && hs.length) {
    var spy = function () {
      var y = window.scrollY + 140, cur = links[0];
      hs.forEach(function (h, i) { if (links[i] && h.offsetTop <= y) cur = links[i]; });
      links.forEach(function (a) { a.classList.toggle('on', a === cur); });
    };
    window.addEventListener('scroll', spy, { passive: true });
    spy();
  }

  /* move the inline capture band before the 3rd visible H2 */
  var band = document.getElementById('av2-band');
  if (band && hs.length >= 3) {
    hs[2].parentNode.insertBefore(band, hs[2]);
    band.hidden = false;
  } else if (band && hs.length) {
    content.appendChild(band);
    band.hidden = false;
  }

  /* re-anchor: the URL hash may point at an element the band move relocated,
     or one the success state hid — scroll to its nearest visible container */
  if (location.hash) {
    var target = document.getElementById(location.hash.slice(1));
    if (target) {
      var vis = target;
      while (vis && (vis.hidden || !vis.offsetHeight)) vis = vis.parentElement;
      if (vis && vis !== document.body) {
        var go = function () { vis.scrollIntoView({ block: 'center' }); };
        requestAnimationFrame(go);
        window.addEventListener('load', function () { setTimeout(go, 60); });
      }
    }
  }
})();

/* In-body YouTube facades (a.ark-ytf). Bodies must never carry raw youtube iframes:
   Google flags the page in GSC Video indexing as "Video isn't on a watch page".
   No-JS fallback: the anchor opens the video on YouTube. */
(function () {
  document.querySelectorAll('a.ark-ytf').forEach(function (b) {
    b.addEventListener('click', function (e) {
      var id = b.getAttribute('data-yt');
      if (!id) return;
      e.preventDefault();
      var d = document.createElement('div');
      d.style.cssText = 'position:relative;padding-top:56.25%;border-radius:8px;overflow:hidden;border:1px solid rgba(28,26,27,.16);box-shadow:0 12px 34px rgba(72,23,47,.14);background:#1c1a1b';
      var f = document.createElement('iframe');
      f.src = 'https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&rel=0';
      f.title = b.getAttribute('aria-label') || 'Video';
      f.allow = 'autoplay; encrypted-media; picture-in-picture';
      f.referrerPolicy = 'strict-origin-when-cross-origin';
      f.allowFullscreen = true;
      f.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;border:0';
      d.appendChild(f);
      b.replaceWith(d);
    });
  });
})();
